import { render, staticRenderFns } from "./UpcomingEventsSlider.vue?vue&type=template&id=e71ebcee&scoped=true&"
import script from "./UpcomingEventsSlider.vue?vue&type=script&lang=js&"
export * from "./UpcomingEventsSlider.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingEventsSlider.vue?vue&type=style&index=0&id=e71ebcee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e71ebcee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VChip,VIcon,VImg})
